/**
 * Card Vault campaign color palette.
 * Used with Panda CSS raw value escape hatch: css({ color: `[${cv.yellow}]` })
 * Self-contained — delete this directory when the campaign ends.
 */
export const cv = {
  black: "#000000",
  dark: "#171717",
  white: "#FFFFFF",
  yellow: "#FFF600",
  orange: "#FFBE0B",
  orangeDark: "#B68500",
  brown: "#3B3733",
  green: "#6BF929",
  blue: "#778C97",
  beige: "#D3C9C0",
  grey: "#B3B3B3",
} as const;
